import CostCodesPage from "./pages/CostCodesPage"

export default CostCodesPage
